<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 8 5"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.00983 4.90492C3.79767 4.90488 3.59422 4.82056 3.44423 4.67052L0.244231 1.47052C0.167823 1.39673 0.106877 1.30845 0.0649495 1.21085C0.0230223 1.11324 0.000953259 1.00827 3.02056e-05 0.902044C-0.000892847 0.795821 0.0193483 0.690477 0.0595731 0.59216C0.0997978 0.493843 0.1592 0.404522 0.234314 0.329408C0.309429 0.254294 0.39875 0.194891 0.497067 0.154667C0.595384 0.114442 0.700728 0.0941999 0.806952 0.095123C0.913175 0.096046 1.01815 0.118115 1.11575 0.160042C1.21336 0.201969 1.30163 0.262916 1.37543 0.339324L4.00983 2.97372L6.64423 0.339324C6.79511 0.193597 6.99719 0.112962 7.20695 0.114785C7.41671 0.116607 7.61736 0.200742 7.76568 0.349069C7.91401 0.497395 7.99815 0.698046 7.99997 0.907803C8.00179 1.11756 7.92116 1.31964 7.77543 1.47052L4.57543 4.67052C4.42544 4.82056 4.22199 4.90488 4.00983 4.90492Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronDown',
};
</script>